import { createLogger } from "logging";
import { environment } from "models/Environment";
import { getRouteParams } from "providers/Params/getRouteParams";

import { BoardType, getBoardRouteKey } from "./boards";
import { trimStart } from "./utils";
const logger = createLogger("helpers/url");

export function prefixApiUrl(url?: string) {
  const before = url || "";
  if (before.startsWith("http")) {
    logger.trace(`prefixApiUrl(): keep absolute ${before}`);
    return before;
  }

  let after = trimStart(before, "/");
  if (!after.startsWith("api")) {
    after = `api/${after}`;
  }

  if (!after.startsWith("http")) {
    after = `${environment.backendUrl}/${after}`;
  }

  Object.entries(getRouteParams()).forEach((entry) => {
    after = replacePlaceholder(after, `:${entry[0]}`, entry[1]);
  });

  if (after !== before) {
    logger.trace(`prefixApiUrl():  ${before} -> ${after}`);
  }

  if (
    after.includes(":boardId") ||
    after.includes(":meetingId") ||
    after.includes(":agendaItemId") ||
    after.includes(":participantId") ||
    after.includes(":documentId") ||
    after.includes(":taskId")
  ) {
    throw new Error(`prefixApiUrl(): Url still contains placeholders: ${after}`);
  }

  return after;
}

export function formatUrlParams(params: object, skipEmpty = true) {
  if (!params) return "";
  const urlParams = new URLSearchParams();
  for (const [name, value] of Object.entries(params)) {
    const valueToUse = value || "";
    if (!valueToUse && skipEmpty) continue;
    urlParams.append(name, valueToUse);
  }
  return urlParams.toString();
}

export function replacePlaceholder(url: string, name: string, value?: string | number): string {
  return value ? url.replace(name, encodeURIComponent(value)) : url;
}

export function replaceRunId(url: string, runId?: string | number): string {
  return replacePlaceholder(url, ":runId", runId);
}

export function replaceBoardId(url: string, board?: BoardType): string {
  const boardRouteKey = getBoardRouteKey(board);
  return replacePlaceholder(url, ":boardId", boardRouteKey);
}

export function replaceMeetingId(url: string, meetingId?: string | number): string {
  return replacePlaceholder(url, ":meetingId", meetingId);
}

export function replaceEndpoint(url: string, endpoint?: string): string {
  return replacePlaceholder(url, ":endpoint", endpoint);
}

export const getBoardApiUrl = (endpoint: string) => {
  return replaceEndpoint(`/api/:boardId/:endpoint`, endpoint);
};

export function checkPlaceholders(url: string) {
  if (url.includes(":")) {
    throw new Error(`Url still contains ':' placeholders: ${url}`);
  }
}
